import { render } from "./Phases.vue?vue&type=template&id=22377945&scoped=true"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"

import "./Phases.vue?vue&type=style&index=0&id=22377945&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22377945"]])

export default __exports__